import React, { useEffect, useState } from "react";
import axios from "axios";
//import "./Accounts.css";

const DiscordChannelSettings = ({ accountId }) => {
    const [channels, setChannels] = useState([]); // Available channels from API
    const [channelSettings, setChannelSettings] = useState([]); // Current settings for this account
    const [newChannel, setNewChannel] = useState({
        discordChannelId: "",
        isEnabled: true,
        tradeSizeMultiplier: 1.0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    // Load available channels from the /discord-channels endpoint.
    useEffect(() => {
        axios
            .get("/discord-channels")
            .then((response) => {
                setChannels(response.data);
            })
            .catch((err) => {
                console.error("Error fetching available channels:", err);
                setError("Failed to load available channels.");
            });
    }, []);

    // Load current channel settings for this account.
    useEffect(() => {
        axios
            .get(`/account/discord-channel-settings/${accountId}`)
            .then((response) => {
                setChannelSettings(response.data);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching discord channel settings:", err);
                setError("Failed to load Discord channel settings.");
                setLoading(false);
            });
    }, [accountId]);

    const handleNewChannelChange = (e) => {
        const { name, value, type, checked } = e.target;
        setNewChannel((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleAddChannel = () => {
        // Prevent adding a channel that is already in settings.
        if (
            channelSettings.some(
                (cs) => cs.discordChannelId.toString() === newChannel.discordChannelId
            )
        ) {
            alert("This channel is already added.");
            return;
        }
        axios
            .post("/account/discord-channel-settings/create", {
                accountId: accountId,
                discordChannelId: newChannel.discordChannelId,
                isEnabled: newChannel.isEnabled,
                tradeSizeMultiplier: newChannel.tradeSizeMultiplier,
            })
            .then((response) => {
                setChannelSettings([...channelSettings, response.data]);
                setNewChannel({ discordChannelId: "", isEnabled: true, tradeSizeMultiplier: 1.0 });
            })
            .catch((error) => {
                console.error("Failed to add discord channel setting:", error);
                alert("Failed to add discord channel setting.");
            });
    };

    const handleUpdateChannel = (updatedSetting) => {
        axios
            .post("/account/discord-channel-settings/update", {
                accountId: updatedSetting.accountId,
                discordChannelId: updatedSetting.discordChannelId,
                isEnabled: updatedSetting.isEnabled,
                tradeSizeMultiplier: updatedSetting.tradeSizeMultiplier,
            })
            .then((response) => {
                setChannelSettings(
                    channelSettings.map((cs) =>
                        cs.discordChannelId === updatedSetting.discordChannelId
                            ? response.data
                            : cs
                    )
                );
            })
            .catch((error) => {
                console.error("Failed to update discord channel setting:", error);
                alert("Failed to update discord channel setting.");
            });
    };

    // Filter available channels to only show those not already added.
    const availableChannels = channels.filter(
        (ch) =>
            !channelSettings.some(
                (cs) => cs.discordChannelId.toString() == ch.id.toString()
            )
    );


    if (loading) return <div>Loading Discord channel settings...</div>;

    return (
        <div className="discord-channel-settings">
            <h3>Discord Channel Settings</h3>
            {error && <div className="error-message">{error}</div>}
            {channelSettings.map((setting) => (
                <div key={setting.discordChannelId} className="channel-setting">
                    <p>
                        Channel ID: {setting.discordChannelId}
                        {setting.name ? ` - ${setting.name}` : ""}
                    </p>
                    <div>
                        <label>
                            Enabled:{" "}
                            <input
                                type="checkbox"
                                checked={setting.isEnabled}
                                onChange={(e) => {
                                    const updated = { ...setting, isEnabled: e.target.checked };
                                    setChannelSettings(
                                        channelSettings.map((cs) =>
                                            cs.discordChannelId === setting.discordChannelId ? updated : cs
                                        )
                                    );
                                }}
                            />
                        </label>
                    </div>
                    <div>
                        <label>
                            Trade Size Percentage:{" "}
                            <input
                                type="number"
                                step="0.01"
                                value={setting.tradeSizeMultiplier}
                                onChange={(e) => {
                                    const updated = {
                                        ...setting,
                                        tradeSizeMultiplier: parseFloat(e.target.value)
                                    };
                                    setChannelSettings(
                                        channelSettings.map((cs) =>
                                            cs.discordChannelId === setting.discordChannelId ? updated : cs
                                        )
                                    );
                                }}
                            />
                        </label>
                    </div>
                    <button onClick={() => handleUpdateChannel(setting)}>Save</button>
                </div>
            ))}
            <div className="new-channel-setting">
                <h4>Add New Discord Channel Setting</h4>
                <label htmlFor="discordChannelId">Select Channel:</label>
                <select
                    name="discordChannelId"
                    id="discordChannelId"
                    value={newChannel.discordChannelId}
                    onChange={handleNewChannelChange}
                >
                    <option value="">-- Select a Channel --</option>
                    {availableChannels.map((ch) => (
                        <option key={ch.id} value={ch.id}>
                            {ch.name ? `${ch.name} (${ch.id})` : ch.id}
                        </option>
                    ))}
                </select>
                <br />
                <label>
                    <input
                        type="checkbox"
                        name="isEnabled"
                        checked={newChannel.isEnabled}
                        onChange={handleNewChannelChange}
                    />
                    Enabled
                </label>
                <br/>
                Trade Size Percentage:
                <input
                    type="number"
                    name="tradeSizeMultiplier"
                    step="0.01"
                    placeholder="Trade Size Percentage"
                    value={newChannel.tradeSizeMultiplier}
                    onChange={handleNewChannelChange}
                />
                <button onClick={handleAddChannel}>Add Channel Setting</button>
            </div>
        </div>
    );
};

export default DiscordChannelSettings;
